export default __webpack_public_path__ + "static/media/central.898257cd.png";